export default __webpack_public_path__ + "img/252001614b3921522cb8bbdf97c564f9.png";